import React, { useEffect, useState } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import { useLoading } from '../Utils/LoadingContext';
import showToast from "../Utils/ToastContainer";

const ClmsEmployee = () => {
    const empcode = localStorage.getItem('empcode');
    const empcompany = localStorage.getItem('empCompany');
    const { setLoading } = useLoading();
    const initialFormState = {
        IsUpdate: "",
        EmployeeCode: "",
        EmployeeName: "",
        FatherName: "",
        DOB: "",
        DOJ: "",
        Gender: "",
        DepartmentID: "",
        SubDepartmentID: "",
        LocationID: "",
        VenderID: "",
        Mobile: "",
        AadharNo: "",
        PermanentAddress: "",
        CurrentAddress: "",
        MaritalStatus: "",
        GradeID: "",
        DesignationID: "",
        PFNumber: "",
        ESICNumber: "",
        BankAccountNo: "",
        BankID: "",
        PANNumber: "",
        CostCenterID: "",
        QualificationID: "",
        PassingYear: "",
        PreviousExperienceYears: "",
        PlantID: "",
        CompanyID: "",
        ShiftID: "",
        ISActive: "",
        ImageFile: null,
        PhysicalDisability: "",
        BloodGroup: "",
        CriticalaManpower: "",
        IFSCCode: "",
        WeekOffID: "",
        ManagerCode: "",
        EmployeeType: "",
        EmployeeStatus: "",
        FloorWise: "",
        LineWise: "",
        EmployeeOldCode: ""

    };
    const [formData, setFormData] = useState(initialFormState);

    const [errors, setErrors] = useState({});
    const [departments, setDepartments] = useState([]);
    const [subDepartments, setSubDepartments] = useState([]);
    const [locations, setLocations] = useState([]);
    const [grades, setGrades] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [banks, setBanks] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [plant, setPlant] = useState([]);
    const [company, setCompany] = useState([]);
    const [shift, setShift] = useState([]);
    const [vender, setVender] = useState([]);
    const [weekOff, setWeekOff] = useState([]);
    const [blood, setBlood] = useState([]);
    const [employeetype, setEmployeeType] = useState([]);
    const [employeestatus, setEmployeeStatus] = useState([]);
    const [floorwise, setFloorWise] = useState([]);
    const [linewise, setLineWise] = useState([]);
    // Load dropdowns once on mount
    useEffect(() => {
        loadDropdowns();
    }, []);
    const loadDropdowns = async () => {
        try {
            const [
                //deptRes,
                locRes,
                gradeRes,
                desigRes,
                bankRes,
                weekOffRes,
                qualRes,
                plantRes,
                companyRes,
                // shiftRes,
                venderRes,
                bloodRes,
                empStatus,
            ] = await Promise.all([
                //EmployeeProcessService.getDepartment(empcode),
                EmployeeProcessService.getLocation(),
                EmployeeProcessService.getGrades(),
                EmployeeProcessService.getDesignation(),
                EmployeeProcessService.getBank(),
                EmployeeProcessService.getWeekOff(),
                EmployeeProcessService.getQualification(),
                EmployeeProcessService.getPlant(empcode),
                EmployeeProcessService.getCompany('User'),
                // EmployeeProcessService.getShift(),
                EmployeeProcessService.getVender('User'),
                EmployeeProcessService.getBlood(),
                EmployeeProcessService.getEmployeeStatus()
            ]);

            // Set each dropdown correctly
            // alert(deptRes.data.result[0].name);
            //if (deptRes?.data?.statusCode === 200) setDepartments(deptRes.data.result);
            if (locRes?.data?.statusCode === 200) setLocations(locRes.data.result);
            if (gradeRes?.data?.statusCode === 200) setGrades(gradeRes.data.result);
            if (desigRes?.data?.statusCode === 200) setDesignations(desigRes.data.result);
            if (bankRes?.data?.statusCode === 200) setBanks(bankRes.data.result);
            if (weekOffRes?.data?.statusCode === 200) setWeekOff(weekOffRes.data.result);
            if (qualRes?.data?.statusCode === 200) setQualifications(qualRes.data.result);
            if (plantRes?.data?.statusCode === 200) setPlant(plantRes.data.result);
            if (companyRes?.data?.statusCode === 200) setCompany(companyRes.data.result);
            // if (shiftRes?.data?.statusCode === 200) setShift(shiftRes.data.result);
            if (venderRes?.data?.statusCode === 200) setVender(venderRes.data.result);
            if (bloodRes?.data?.statusCode === 200) setBlood(bloodRes.data.result);
            if (empStatus?.data?.statusCode === 200) setEmployeeStatus(empStatus.data.result);
        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };
    const handleClear = () => {
        setFormData(initialFormState);
        setErrors({});
    };
    // Handle input changes
    const handleChange = async (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        try {
            if (name === "CompanyID") {
                // When company changes → fetch plants for that company
                const plantResponse = await EmployeeProcessService.getPlantByCompany(value);
                if (plantResponse.data.statusCode === 200) {
                    setPlant(plantResponse.data.result);
                } else {
                    setPlant([]);
                }
                // Reset plant & below dependencies
                setFormData((prev) => ({ ...prev, PlantID: "", DepartmentID: "", SubDepartmentID: "" }));
                setDepartments([]);
                setSubDepartments([]);
            }

            if (name === "PlantID") {
                debugger;
                // When plant changes → fetch shift
                const shiftResponse = await EmployeeProcessService.getShift(value);
                if (shiftResponse.data.statusCode === 200) {
                    setShift(shiftResponse.data.result);
                } else {
                    setShift([]);
                }

                // Fetch employee code
                const empResponse = await EmployeeProcessService.getEployeeCode(value);
                if (empResponse.data.statusCode === 200 && empResponse.data.result) {
                    const employeeData = empResponse.data.result[0].id;
                    setFormData((prev) => ({
                        ...prev,
                        IsUpdate: 0,
                        ISActive: 1,
                        EmployeeCode: employeeData || ""
                    }));
                } else {
                    setFormData((prev) => ({ ...prev, EmployeeCode: "" }));
                }

                // Fetch departments bound by plant
                const departmentResponse = await EmployeeProcessService.getDepartment(empcode, value);
                if (departmentResponse.data.statusCode === 200) {
                    setDepartments(departmentResponse.data.result);
                } else {
                    setDepartments([]);
                }

                // Fetch Floor Wise bound by plant
                const floorResponse = await EmployeeProcessService.getFloorWise(value);
                if (floorResponse.data.statusCode === 200) {
                    setFloorWise(floorResponse.data.result);
                } else {
                    setFloorWise([]);
                }

                // Fetch Line Wise bound by plant
                // const lineResponse = await EmployeeProcessService.getLineWise(value);
                // if (lineResponse.data.statusCode === 200) {
                //     setLineWise(lineResponse.data.result);
                // } else {
                //     setLineWise([]);
                // }

                // Reset subdepartments
                setSubDepartments([]);
                setFormData((prev) => ({ ...prev, DepartmentID: "", SubDepartmentID: "" }));
            }

            if (name === "DepartmentID") {
                // When department changes → fetch sub-departments
                const response = await EmployeeProcessService.getSubDepartment(value);
                if (response.data.statusCode === 200) {
                    setSubDepartments(response.data.result);
                } else {
                    setSubDepartments([]);
                }
                setFormData((prev) => ({ ...prev, SubDepartmentID: "" }));
            }
            if (name === "FloorWise") {
                // Clear currently selected line
                setFormData(prev => ({
                    ...prev,
                    FloorWise: value
                    
                }));

                // If no floor selected, clear lines
                if (!value) {
                    setLineWise([]);
                    return;
                }

                try {
                    // Pass selected Floor ID to API
                    const lineResponse = await EmployeeProcessService.getLineWise(value);

                    if (lineResponse.data.statusCode === 200) {
                        setLineWise(lineResponse.data.result);
                    } else {
                        setLineWise([]);
                    }
                } catch (error) {
                    console.error("Error fetching lines:", error);
                    setLineWise([]);
                }
            }

        } catch (error) {
            console.error("Error in handleChange:", error);
        }
    };


    const validate = () => {
        const newErrors = {};
        //const requiredFields = ['EmployeeName', 'FatherName', 'DOB', 'DOJ', 'Gender', 'Mobile', 'AadharNo'];
        const requiredFields = ['CompanyID', 'EmployeeName', 'FatherName', 'DOB', 'DOJ', 'PlantID', 'Gender', 'Mobile',
            'AadharNo', 'VenderID', 'Gender', 'DepartmentID', 'PermanentAddress', 'ShiftID', 'WeekOffID', 'DesignationID', 'GradeID', 'EmployeeType'];

        requiredFields.forEach(field => {
            if (!formData[field] || formData[field].toString().trim() === '') {
                newErrors[field] = 'This field is required';
            }
        });

        if (formData.Mobile && !/^\d{10}$/.test(formData.Mobile)) {
            newErrors.Mobile = 'Invalid mobile number';
        }

        if (formData.AadharNo && !/^\d{12}$/.test(formData.AadharNo)) {
            newErrors.AadharNo = 'Invalid Aadhar number';
        }


        if (formData.DOB && !is18OrOlder(formData.DOB)) {
            newErrors.DOB = 'Employee must be at least 18 years old.';
        }

        // if (formData.DOJ && formData.DOB && new Date(formData.DOJ) < new Date(formData.DOB)) {
        //     newErrors.DOJ = 'DOJ cannot be before DOB.';
        // } else if (formData.DOJ && !is18OrOlder(formData.DOJ)) {
        //     newErrors.DOJ = 'Employee must be at least 18 years old on DOJ.';
        // }
        console.log("Validation Errors:", newErrors);
        return newErrors;
    };
    const is18OrOlder = (dateString) => {
        const dob = new Date(dateString);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();
        const m = today.getMonth() - dob.getMonth();
        return age > 18 || (age === 18 && m >= 0);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }
        console.log("Validation Errors:", validationErrors);
        setErrors({}); // Clear previous errors

        try {
            setFormData(prev => ({
                ...prev,
                IsUpdate: 0,
                ISActive: 1,
            }));
            const form = new FormData();
            Object.keys(formData).forEach(key => {
                if (formData[key] !== null && formData[key] !== '') {
                    form.append(key, formData[key]);
                }
            });

            const response = await EmployeeProcessService.setEmployee(form);
            if (response.success && response.data.statusCode === 200) {
                const empId = response.data.result;
                handleClear();
                localStorage.setItem('employeeId', empId);
                showToast("Employee inserted successfully.", 'success', { autoClose: 1500 });
            } else {
                const message = response.errorMessage || 'Submission failed. Please try again.';
                toast.error(message);
            }
        } catch (error) {
            const message = error?.message || 'Unexpected error occurred.';
            toast.error(message);
            console.error("Unhandled error:", message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <form>
            <div className="row ">
                <div className="col-12 mb-3 border-bottom pb-2">
                    <h4 className="text-left text-primary">Employee Setup</h4>
                </div>
                <h7 className="text-start fw-bold text-info pb-2 mb-1" style={{ backgroundColor: 'whitesmoke' }} >
                    <i className="bi bi-building"></i>
                    Company & Employment Details
                </h7>
                <div className="form-group col-md-4">
                    <label>
                        Company<span style={{ color: 'red' }}>*</span>
                    </label>
                    <select
                        name="CompanyID"
                        value={formData.CompanyID}
                        onChange={handleChange}
                        className="form-select"
                    >
                        <option value="">Select Company</option>

                        {company
                            // .filter(comp => comp.name === empcompany)
                            .map(comp => (
                                <option key={comp.id} value={comp.id}>
                                    {comp.name}
                                </option>
                            ))}
                    </select>
                    <div className="text-danger">{errors.CompanyID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Plant<span style={{ color: 'red' }}>*</span></label>
                    <select name="PlantID" value={formData.PlantID} onChange={handleChange} className="form-select">
                        <option value="">Select Plant</option>
                        {plant.map(plan => (
                            <option key={plan.id} value={plan.id}>{plan.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.PlantID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>New Employee Code<span style={{ color: 'red' }}>*</span></label>
                    <input name="EmployeeCode" value={formData.EmployeeCode} readOnly className="form-control bg-light" />
                </div>
                <div className="form-group col-md-4">
                    <label>Employee Name<span style={{ color: 'red' }}>*</span></label>
                    <input name="EmployeeName" value={formData.EmployeeName} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.EmployeeName}</div>
                </div>

                <div className="form-group col-md-4">
                    <label>Father Name<span style={{ color: 'red' }}>*</span></label>
                    <input name="FatherName" value={formData.FatherName} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.FatherName}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>DOB<span style={{ color: 'red' }}>*</span></label>
                    <input type="date" name="DOB" value={formData.DOB} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.DOB}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>DOJ<span style={{ color: 'red' }}>*</span></label>
                    <input type="date" name="DOJ" value={formData.DOJ} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.DOJ}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Gender<span style={{ color: 'red' }}>*</span></label>
                    <select name="Gender" value={formData.Gender} onChange={handleChange} className="form-select">
                        <option value="">Select Gender</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        <option value="O">Other</option>
                    </select>
                    <div className="text-danger">{errors.Gender}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Marital Status<span style={{ color: 'red' }}>*</span></label>
                    <select name="MaritalStatus" value={formData.MaritalStatus} onChange={handleChange} className="form-select">
                        <option value="">Select Status</option>
                        <option value="Unmarried">Unmarried</option>
                        <option value="Married">Married</option>
                        <option value="Divorced">Divorced</option>
                    </select>
                    <div className="text-danger">{errors.MaritalStatus}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Physical Disability</label>
                    <select name="PhysicalDisability" value={formData.PhysicalDisability} onChange={handleChange} className="form-select">
                        <option value="">Select Value</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <div className="text-danger">{errors.ISActive}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Blood Group</label>
                    {/* <input name="BloodGroup" value={formData.BloodGroup} onChange={handleChange} className="form-control" /> */}
                    <select name="BloodGroup" value={formData.BloodGroup} onChange={handleChange} className="form-select">
                        <option value="">Select Blood</option>
                        {blood.map(blood => (
                            <option key={blood.id} value={blood.id}>{blood.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.BloodGroup}</div>
                </div>

                <div className="form-group col-md-4">
                    <label>Manager Code<span style={{ color: 'red' }}>*</span></label>
                    <input name="ManagerCode" value={formData.ManagerCode} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.ManagerCode}</div>
                </div>

                <h7 className="text-start fw-bold text-info pb-2 mb-1" style={{ backgroundColor: 'whitesmoke' }} >
                    <i className="bi bi-building"></i>  Work Information</h7>

                <div className="form-group col-md-4">
                    <label>Shift <span style={{ color: 'red' }}>*</span></label>
                    <select name="ShiftID" value={formData.ShiftID} onChange={handleChange} className="form-select">
                        <option value="">Select Shift</option>
                        {shift.map(sft => (
                            <option key={sft.id} value={sft.id}>{sft.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.ShiftID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Department<span style={{ color: 'red' }}>*</span></label>
                    <select name="DepartmentID" value={formData.DepartmentID} onChange={handleChange} className="form-select">
                        <option value="">Select Department</option>
                        {departments.map(dept => (
                            <option key={dept.id} value={dept.id}>{dept.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.DepartmentID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Sub Department<span style={{ color: 'red' }}>*</span></label>
                    <select name="SubDepartmentID" value={formData.SubDepartmentID} onChange={handleChange} className="form-select">
                        <option value="">Select Sub Department</option>
                        {subDepartments.map(sub => (
                            <option key={sub.id} value={sub.id}>{sub.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.SubDepartmentID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Designation<span style={{ color: 'red' }}>*</span></label>
                    <select name="DesignationID" value={formData.DesignationID} onChange={handleChange} className="form-select">
                        <option value="">Select Designation</option>
                        {designations.map(d => (
                            <option key={d.id} value={d.id}>{d.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.DesignationID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Grade<span style={{ color: 'red' }}>*</span></label>
                    <select name="GradeID" value={formData.GradeID} onChange={handleChange} className="form-select">
                        <option value="">Select Grade</option>
                        {grades.map(g => (
                            <option key={g.id} value={g.id}>{g.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.GradeID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Cost Center</label>
                    <input name="CostCenterID" value={formData.CostCenterID} onChange={handleChange}
                        onKeyDown={(e) => {
                            // Allow: backspace, delete, tab, escape, enter, arrows
                            if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "Escape" ||
                                e.key === "Enter" ||
                                (e.key >= "0" && e.key <= "9") ||
                                e.key.startsWith("Arrow")
                            ) {
                                return;
                            }

                            e.preventDefault(); // Block the key
                            alert("Only numbers are allowed.");
                        }} className="form-control" />
                    <div className="text-danger">{errors.CostCenterID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Location<span style={{ color: 'red' }}>*</span></label>
                    <select name="LocationID" value={formData.LocationID} onChange={handleChange} className="form-select">
                        <option value="">Select Location</option>
                        {locations.map(loc => (
                            <option key={loc.id} value={loc.id}>{loc.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.LocationID}</div>
                </div>


                <div className="form-group col-md-4">
                    <label>Vendor<span style={{ color: 'red' }}>*</span></label>
                    <select name="VenderID" value={formData.VenderID} onChange={handleChange} className="form-select">
                        <option value="">Select Vendor</option>
                        {vender.map(ven => (
                            <option key={ven.id} value={ven.id}>{ven.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.VenderID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Week Off <span style={{ color: 'red' }}>*</span></label>
                    <select name="WeekOffID" value={formData.WeekOffID} onChange={handleChange} className="form-select">
                        <option value="">Select WeekOff</option>
                        {weekOff.map(week => (
                            <option key={week.id} value={week.id}>{week.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.WeekOffID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Critical Manpower</label>
                    <select name="CriticalaManpower" value={formData.CriticalaManpower} onChange={handleChange} className="form-select">
                        <option value="">Select Value</option>
                        <option value="1">Yes</option>
                        <option value="0">NO</option>
                    </select>
                    <div className="text-danger">{errors.CriticalaManpower}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Employee Type<span style={{ color: 'red' }}>*</span></label>
                    <select name="EmployeeType" value={formData.EmployeeType} onChange={handleChange} className="form-select">
                        <option value="">Select Type</option>
                        <option value="Contractual">Contractual</option>
                        <option value="Permanent">Permanent</option>
                    </select>
                    <div className="text-danger">{errors.EmployeeType}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Employee Status</label>
                    <select name="EmployeeStatus" value={formData.EmployeeStatus} onChange={handleChange} className="form-select">
                        <option value="">Select Status</option>
                        {employeestatus.map(status => (
                            <option key={status.id} value={status.id}>{status.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.EmployeeStatus}</div>
                </div>

                <div className="form-group col-md-4">
                    <label>Floor Wise</label>
                    <select name="FloorWise" value={formData.FloorWise} onChange={handleChange} className="form-select">
                        <option value="">Select Floor</option>
                        {floorwise.map(floors => (
                            <option key={floors.id} value={floors.id}>{floors.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.FloorWise}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Line Wise</label>
                    <select name="LineWise" value={formData.LineWise} onChange={handleChange} className="form-select" disabled={!formData.FloorWise}>
                        <option value="">Select Line</option>
                        {linewise.map(line => (
                            <option key={line.id} value={line.id}>{line.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.LineWise}</div>
                </div>

                <div className="form-group col-md-4">
                    <label>Employee OLD Code</label>
                    <input name="EmployeeOldCode" value={formData.EmployeeOldCode} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.EmployeeOldCode}</div>
                </div>


                <h7 className="text-start fw-bold text-info pb-2 mb-1" style={{ backgroundColor: 'whitesmoke' }} >
                    <i className="bi bi-building"></i>  Contact & Identification</h7>

                <div className="form-group col-md-4">
                    <label>Aadhar No<span style={{ color: 'red' }}>*</span></label>
                    <input name="AadharNo" value={formData.AadharNo} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.AadharNo}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>PAN Number</label>
                    <input name="PANNumber" value={formData.PANNumber} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.PANNumber}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Mobile Number<span style={{ color: 'red' }}>*</span></label>
                    <input name="Mobile" value={formData.Mobile} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.Mobile}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Permanent Address <span style={{ color: 'red' }}>*</span></label>
                    <input name="PermanentAddress" value={formData.PermanentAddress} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.PermanentAddress}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Current Address</label>
                    <input name="CurrentAddress" value={formData.CurrentAddress} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.CurrentAddress}</div>
                </div>

                <h7 className="text-start fw-bold text-info pb-2 mb-1" style={{ backgroundColor: 'whitesmoke' }} >
                    <i className="bi bi-building"></i> Bank & Statutory Details</h7>

                <div className="form-group col-md-4">
                    <label>PF Number</label>
                    <input name="PFNumber" value={formData.PFNumber} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.PFNumber}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>ESIC Number</label>
                    <input name="ESICNumber" value={formData.ESICNumber} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.ESICNumber}</div>
                </div>

                <div className="form-group col-md-4">
                    <label>Bank</label>
                    <select name="BankID" value={formData.BankID} onChange={handleChange} className="form-select">
                        <option value="">Select Bank</option>
                        {banks.map(b => (
                            <option key={b.id} value={b.id}>{b.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.BankID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Bank Account No</label>
                    <input name="BankAccountNo" value={formData.BankAccountNo} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.BankAccountNo}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Bank IFSC Code</label>
                    <input name="IFSCCode" value={formData.IFSCCode} onInput={(e) => e.target.value = e.target.value.toUpperCase()} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.IFSCCode}</div>
                </div>
                <h7 className="text-start fw-bold text-info pb-2 mb-1" style={{ backgroundColor: 'whitesmoke' }}>
                    <i className="bi bi-building"></i> Qualification & Experience</h7>

                <div className="form-group col-md-4">
                    <label>Qualification</label>
                    <select name="QualificationID" value={formData.QualificationID} onChange={handleChange} className="form-select">
                        <option value="">Select Qualification</option>
                        {qualifications.map(q => (
                            <option key={q.id} value={q.id}>{q.name}</option>
                        ))}
                    </select>
                    <div className="text-danger">{errors.QualificationID}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Passing Year</label>
                    <input name="PassingYear" value={formData.PassingYear} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.PassingYear}</div>
                </div>
                <div className="form-group col-md-4">
                    <label>Previous Experience (Years)</label>
                    <input name="PreviousExperienceYears" value={formData.PreviousExperienceYears} onChange={handleChange} className="form-control" />
                    <div className="text-danger">{errors.PreviousExperienceYears}</div>
                </div>
                <div className="col-12 mt-3 text-center">
                    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
                        Save Employee
                    </button>
                </div>
            </div>
        </form>
    );
};

export default ClmsEmployee;
